<!-- @format -->

<sis-description-list [columnCount]="1">
  <dl>
    @for (codeBook of codebooks; track codeBook) {
      <ng-template #listItem>
        <dt class="sis-label">{{ codeBook.name | localizedString }}</dt>
        <dd>
          @for (codeUrn of customCodesByCodebookUrnMap[codeBook.urn]; track codeUrn) {
            <p>
              {{ customCodes[codeUrn]?.name | localizedString }}
            </p>
          }
        </dd>
      </ng-template>
    }
  </dl>
</sis-description-list>
